import React, { useState, useRef, useEffect } from 'react';
import { CalendarPlus, Check } from 'lucide-react';

const pad = (n) => String(n).padStart(2, '0');
const toICS = (d) => {
  const dt = new Date(d);
  return `${dt.getUTCFullYear()}${pad(dt.getUTCMonth() + 1)}${pad(dt.getUTCDate())}T${pad(dt.getUTCHours())}${pad(dt.getUTCMinutes())}${pad(dt.getUTCSeconds())}Z`;
};

const AddToCalendar = ({ title, description = '', location = '', start, end, url = '' }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    if (open) document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  if (!start) return null;
  const startISO = start;
  const endISO = end || new Date(new Date(start).getTime() + 60 * 60 * 1000).toISOString();
  const details = [description, url].filter(Boolean).join('\n\n');

  const google = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&dates=${toICS(startISO)}/${toICS(endISO)}&details=${encodeURIComponent(details)}&location=${encodeURIComponent(location)}`;

  const downloadICS = () => {
    const ics = [
      'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Osho Universal//EN', 'BEGIN:VEVENT',
      `UID:${Date.now()}@oshouniversal.org`, `DTSTAMP:${toICS(new Date().toISOString())}`,
      `DTSTART:${toICS(startISO)}`, `DTEND:${toICS(endISO)}`,
      `SUMMARY:${title}`, `DESCRIPTION:${details.replace(/\n/g, '\\n')}`, `LOCATION:${location}`,
      'END:VEVENT', 'END:VCALENDAR',
    ].join('\r\n');
    const blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `${(title || 'event').replace(/[^a-z0-9]+/gi, '-').toLowerCase()}.ics`;
    a.click();
    URL.revokeObjectURL(a.href);
    setOpen(false);
  };

  return (
    <div className="relative inline-block" ref={ref}>
      <button onClick={() => setOpen((o) => !o)} className="pill-btn-outline" data-testid="add-to-calendar">
        <CalendarPlus className="w-4 h-4" /> Add to Calendar
      </button>
      {open && (
        <div className="absolute left-0 z-30 mt-2 w-52 p-2 rounded-2xl bg-white border border-rose/50 shadow-xl" data-testid="calendar-popover">
          <a href={google} target="_blank" rel="noopener noreferrer" onClick={() => setOpen(false)} data-testid="cal-google"
            className="w-full flex items-center gap-3 px-3 py-2 rounded-xl text-sm text-burgundy hover:bg-rose-soft/40"><Check className="w-4 h-4 text-mahogany/60" /> Google Calendar</a>
          <button onClick={downloadICS} data-testid="cal-ics" className="w-full flex items-center gap-3 px-3 py-2 rounded-xl text-sm text-burgundy hover:bg-rose-soft/40"><Check className="w-4 h-4 text-mahogany/60" /> Apple / Outlook (.ics)</button>
        </div>
      )}
    </div>
  );
};

export default AddToCalendar;
